import { render } from "./MedicalView.vue?vue&type=template&id=596cf497&scoped=true&ts=true"
import script from "./MedicalView.vue?vue&type=script&lang=ts"
export * from "./MedicalView.vue?vue&type=script&lang=ts"

import "./MedicalView.vue?vue&type=style&index=0&id=596cf497&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596cf497"]])

export default __exports__